



























































import Picture from '@/pages/profile/blocks/cards/components/picture/Picture.vue';
// TODO: надо вообще всю карточку на фиг переделывать, это жесть, в особенности убрать зависимость от другого модуля
import Message from '@/pages/profile/blocks/cards/purchases/components/message/Message.vue';
import Cancellation from '@/pages/profile/blocks/cards/purchases/components/cancellation/Cancellation.vue';
import { routeParse } from '@/pages/profile/utils';
import { OrderStatusConfig } from '@/pages/profile/views/purchases/types';

export default {
  name: 'PurchasesCard',

  components: {
    Picture,
    Message,
    Cancellation,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpenComment: false,
    };
  },

  computed: {
    orderStatusConfig() {
      return OrderStatusConfig;
    },
    orderCancelReasonDict() {
      return this.$store.state.orderCancelReasonDict;
    },
  },

  methods: {
    hide() {
      this.$emit('hide');
    },

    parse(val) {
      return this.$router.resolve(routeParse(val.id, val.event.url_code)).href;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchaseEventCard/PurchaseEventCard.vue